<template>
  <div class="panel panel-primary">
    <slot name="header">
      <h2 class="ml-10">{{ isSelfAssessmentOn ? 'Skill Gap' : 'Skill Score' }}</h2>
    </slot>
    <div class="panel-body">
      <div class="lead">
        <div class="mb-5">Legend of bar</div>
        <template v-if="versionKey !== 70 && isSelfAssessment && isSelfAssessmentOn">
          <div>
            <circle-icon :radius="10" :color="'#003f54'" role="img" title="circle"></circle-icon>
            Self-Assessment Score
          </div>
        </template>
        <div>
          <rect-icon :size="20" :color="'#003f54'" role="img" title="rectangle"></rect-icon> Inbox
          Assessment Score
        </div>
      </div>
      <table class="lead">
        <template v-for="skill in skills">
          <tr v-if="isPrint">
            <td style="padding: 40px 10px 0px 10px !important">
              <b>{{ skill.name }}</b>
              <br />
              {{ skill.description }}
            </td>
          </tr>
          <tr>
            <th v-if="!isPrint">
              {{ skill.name }}
              <button
                class="remove-button-style glyphicon glyphicon-info-sign ml-5"
                data-toggle="popover"
                data-placement="top"
                :data-content="skill.description"
                :title="skill.name"
              ></button>

              <!-- <a tabindex="0" class="hidden-print" data-toggle="tooltip" data-placement="top" :title='skill.description' data-original-title>
								<span class="glyphicon glyphicon-info-sign"></span>
								</a> -->
            </th>
            <td :style="{ isPrint: 'padding: 35px 10px 40px 10px !important' }">
              <div class="progress" style="position: relative; overflow: visible">
                <div
                  class="progress-bar progress-bar-danger progress-bar-striped"
                  style="width: 29%"
                  title="Your percentile is between 0%-30%"
                ></div>
                <div
                  class="progress-bar progress-bar-warning progress-bar-striped"
                  style="width: 39%"
                  title="Your percentile is between 30%-70%"
                ></div>
                <div
                  class="progress-bar progress-bar-success progress-bar-striped"
                  style="width: 32%"
                  title="Your percentile is between 70%-100%"
                ></div>
                <div style="width: 97%; position: relative">
                  <span
                    v-bind:style="`left: ${
                      skill.gameScore.length == 1
                        ? parseInt(skill.gameScore) + 0.5
                        : skill.gameScore
                    }%;position: absolute; top: 30px;}`"
                    aria-label="Inbox Assessment Score"
                    >{{ skill.gameScore }}
                  </span>
                  <template v-if="versionKey !== 70 && isSelfAssessment && isSelfAssessmentOn">
                    <span
                      v-bind:style="`left: ${
                        skill.selfScore - 0.2
                      }%;position: absolute; top: -35px;}`"
                      aria-label="Self-Assessment Score"
                      >{{ skill.selfScore }}
                    </span>
                  </template>
                  <span
                    v-bind:style="`left: ${skill.gameScore}%;position: absolute; top: 10px;}`"
                    aria-hidden="true"
                  >
                    <rect-icon
                      :size="20"
                      :color="'#003f54'"
                      role="img"
                      title="rectangle"
                    ></rect-icon>
                  </span>
                  <template v-if="versionKey !== 70 && isSelfAssessment && isSelfAssessmentOn">
                    <span
                      v-bind:style="`left: ${skill.selfScore}%;position: absolute; top: -10px;}`"
                      aria-hidden="true"
                    >
                      <circle-icon
                        :radius="10"
                        :color="'#003f54'"
                        role="img"
                        title="circle"
                      ></circle-icon>
                    </span>
                  </template>
                </div>
              </div>
            </td>
          </tr>
        </template>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SkillGap',

    props: {
      isSelfAssessment: {
        type: Boolean,
        required: true,
        default: true,
      },
      skills: {
        required: true,
      },
      isPrint: {
        type: Boolean,
        required: false,
        default: false,
      },
      isSelfAssessmentOn: {
        type: Boolean,
        required: true,
        default: true,
      },
    },

    computed: {
      versionKey() {
        if (this.$store.state) {
          return this.$store.state.versionKey;
        }
      },
    },

    mounted() {
      $('[data-toggle="tooltip"]').tooltip();
      $('[data-toggle="popover"]').popover();
      $(document).keyup(function (event) {
        if (event.which === 27) {
          $('[data-toggle="popover"]').popover('hide');
        }
      });
    },
  };
</script>

<style scoped lang="scss">
  .panel {
    width: 100%;
  }

  .progress-row {
    border-top: 1px solid #e3e3e3;
    border-bottom: 1px solid #e3e3e3;
    padding: 10px;
  }

  table {
    width: 100%;
    margin-bottom: 20px;
    tr {
      th:first-child {
        width: 250px;
      }
      td {
        padding: 40px 10px;
      }
    }
    .progress {
      margin-bottom: 0;
    }
  }
  .spacing-left {
    margin-left: 15px;
  }
  .spacing-right {
    margin-right: 15px;
  }

  @media print {
    .skill-gap {
      margin-top: 100px !important;
    }

    .progress {
      -webkit-print-color-adjust: exact !important;
      width: 100%;

      .progress-bar {
        width: 100%;
        -webkit-print-color-adjust: exact !important;

        &.progress-bar-danger {
          background-color: #d9534f !important;
          -webkit-print-color-adjust: exact !important;
        }

        &.progress-bar-warning {
          background-color: #f0ad4e !important;
          -webkit-print-color-adjust: exact !important;
        }

        &.progress-bar-success {
          background-color: #5cb85c !important;
          -webkit-print-color-adjust: exact !important;
        }
      }
    }
  }
</style>
